"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const Form_1 = __importDefault(require("react-bootstrap/Form"));
// eslint-disable-next-line @typescript-eslint/no-var-requires
const parse = require("loose-json");
const JsonComponent = (props) => {
    const { schema } = props;
    const { value, registerProps, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
    ]);
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState },
        react_1.default.createElement(Form_1.default.Control, Object.assign({ as: "textarea", rows: schema.rows || 6, className: (0, classnames_1.default)({
                "has-error": fieldState.invalid,
            }), value: JSON.stringify(value, null, 4) }, registerProps, { onChange: (e) => {
                try {
                    registerProps.onChange(parse(e.currentTarget.value));
                }
                catch (e) {
                    registerProps.onChange("");
                }
            } }))));
};
JsonComponent.display = (0, displayWrapper_1.DisplayComponent)("MultilineDisplayComponent");
exports.default = JsonComponent;
